import { FastAverageColor, FastAverageColorResource } from 'fast-average-color';
import invert from 'invert-color';
import { useEffect } from 'react';

import { COLORS } from '@/styles/tokens/colors';

const averageColorCalculator = new FastAverageColor();

interface UsePDFViewerColorsProps {
  element: FastAverageColorResource;
  isFocused: boolean;
}

export function usePDFViewerColors({
  element,
  isFocused,
}: UsePDFViewerColorsProps) {
  useEffect(() => {
    return () => {
      averageColorCalculator.destroy();
    };
  }, []);

  const averageColor = averageColorCalculator.getColor(element, {
    algorithm: 'simple',
    mode: 'speed',
    step: 1,
  });

  // If focused, highlight the background in teal, with a darker teal border.
  // If unfocused, no background, but show border.
  const backgroundColor = invert(averageColor.hex, {
    black: isFocused ? COLORS.TEAL[100] : 'transparent',
    white: isFocused ? COLORS.TEAL[100] : 'transparent',
    threshold: 0.5,
  });

  const borderColor = COLORS.TEAL[500];

  return {
    averageColor,
    backgroundColor,
    borderColor,
  };
}
